import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import * as callActionCreators from "store/actions/call";
import SVGSpinner from "components/SVGSpinner";
import MainLogoWhite from "components/MainLogoWhite";
import { test } from "utils/helpers";
import "./JoiningCallScreen.scss";
import * as googleAnalytics from "../../store/actions/googleAnalytics";
import useSetInterpreterStatus from "containers/InviteToCall/Popup/Tabs/Interpreter/hook/useSetInterpreterStatus";

const mapStateToProps = ({ call, config }) => ({
  isCallActive: call.active,
  disconnectReason: call.disconnectReason,
  gcpServices: config.listOfGCPServices,
  interpreterSessionId: config.interpreterSessionId?.value,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(callActionCreators, dispatch),
  ...bindActionCreators(googleAnalytics, dispatch),
});

const JoiningCallScreen = ({
  isCallActive,
  disconnectReason,
  interpreterSessionId,
  endCall,
  interpreterJoinedSession,
  interpreterJoinedExpiredSession,
}) => {
  const location = useLocation();
  const { t } = useTranslation();
  let navigate = useNavigate();
  const interpreterStatus = useSetInterpreterStatus();
  const INTERPRETER_STATUS = {
    PENDING: "0",
    JOINED: "1",
    COMPLETED: "2",
    CANCELLED: "3",
  };
  if (disconnectReason) {
    return disconnectReason === "VIDYO_CONNECTORFAILREASON_InvalidToken" ? (
      <Navigate replace to={"/GuestAccessCodeScreen"} state={location.state} />
    ) : (
      <Navigate
        replace
        to={"/GuestBeautyScreen"}
        state={{
          ...location.state,
          isRedirectFromAccessCodeScreen: false,
        }}
      />
    );
  }

  if (isCallActive && interpreterSessionId === "") {
    return (
      <Navigate
        replace
        to={"/GuestInCall"}
        state={{
          ...location.state,
          isRedirectFromAccessCodeScreen: false,
        }}
      />
    );
  }

  const isSessionValid = (response) => {
    if (
      response?.status === INTERPRETER_STATUS.COMPLETED ||
      response?.status === INTERPRETER_STATUS.CANCELLED
    ) {
      return false;
    }
    if (response?.successful || !response?.successful) {
      return true;
    }
    return false;
  };

  const interPreterJoined = async () => {
    try {
      const res = await interpreterStatus.interpreterJoined();
      if (res === null) {
        return;
      }
      if (isSessionValid(res)) {
        interpreterJoinedSession(interpreterSessionId);
        navigate("/GuestInCall", {
          state: { ...location.state, isRedirectFromAccessCodeScreen: false },
        });
      } else if (res?.successful === false) {
        endCall();
        interpreterStatus.interpreterLeft();
        interpreterJoinedExpiredSession(interpreterSessionId);
        navigate("/InterpreterPostCall", {
          state: { ...location.state, isRedirectFromAccessCodeScreen: false },
        });
      }
    } catch (e) {}
  };

  if (isCallActive && interpreterSessionId !== "") {
    interPreterJoined();
  }

  return (
    <div className="joining-call-screen" {...test("GUEST_JOINING_SCREEN")}>
      <div className="content">
        <MainLogoWhite />
        <div className="initial-loader">
          <SVGSpinner strokeColor="#51575C" />
        </div>
        <div role="alert" aria-live="assertive" className="message">
          {t("JOINING_CALL_DOTS")}
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(JoiningCallScreen);
